export const types = {
    SHOW_ALL_MOVIES_ON_SEARCH :"SHOW_ALL_MOVIES_ON_SEARCH", 
    ADD_TO_WATCHLIST : "ADD_TO_WATCHLIST",
    ADD_TO_WATCHED : "ADD_TO_WATCHED",
    REMOVE_FROM_WATCHED : "REMOVE_FROM_WATCHED",
    REMOVE_FROM_WATCHLIST : "REMOVE_FROM_WATCHLIST",
}